import { render } from "./CadastroListaServicosExtrasView.vue?vue&type=template&id=92c61930"
import script from "./CadastroListaServicosExtrasView.vue?vue&type=script&lang=js"
export * from "./CadastroListaServicosExtrasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__